import { SHOW_APP_LOADING, HIDE_APP_LOADING } from '../actions/appLoading';

const initialState = {
  isLoading: false,
  message: '',
};

export default function appLoadingReducer(state = initialState, action) {
  const { payload, type } = action;
  switch (type) {
    case SHOW_APP_LOADING:
      return {
        ...state,
        isLoading: true,
        message: payload.message,
      };
    case HIDE_APP_LOADING:
      return {
        ...state,
        isLoading: false,
        message: '',
      };
    default:
      return state;
  }
}
